import { Box, ListItemText, List, ListItem, Typography, Link, Theme } from "@mui/material";
import React, { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Icon, SizeProp, iconArrowLeft } from "theme/icons";
import { styleFlex, styleFlexAlignItemsCenter, styleFlexJustifyContentBetween } from "theme/styles";
import { testId } from "tests/testIdStrings";

interface IHeaderNavigationProps {
  iconSize: SizeProp;
  topTitle: string;
  title: string;
  children?: ReactNode;
  onNavigate?: () => void;
}
export const HeaderNavigation: React.FC<IHeaderNavigationProps> = (props) => {
  const isMediumOrSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (props.onNavigate) return props.onNavigate();

    navigate(-1);
  };

  return (
    <List sx={{ width: isMediumOrSmallScreen ? "100%" : "30%" }} disablePadding>
      <ListItem sx={[styleFlex, styleFlexJustifyContentBetween, { paddingLeft: 1, paddingRight: 1 }]}>
        <Box sx={[styleFlex, styleFlexAlignItemsCenter, { height: "2rem", width: "100%" }]}>
          <Link onClick={handleNavigate} sx={{ color: "white" }} data-testid={testId.menu.header.backButton}>
            {<Icon name={iconArrowLeft} size={props.iconSize} />}
          </Link>
          <ListItemText
            disableTypography
            primary={<Typography variant="caption">{props.topTitle}</Typography>}
            secondary={
              <Typography
                variant="h4"
                style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                data-testid={testId.menu.header.pageTitle}
              >
                {props.title}
              </Typography>
            }
            sx={{ margin: "0 1rem", lineHeight: "1rem" }}
          />
        </Box>
        {/* Högerställda icons */}
        {props.children}
      </ListItem>
    </List>
  );
};
